import React, { useState, useEffect, Fragment } from 'react'
import './AddOrEditInstitutionCategory.css';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { addInstitutionCategory, getInstitutionCategories, getInstitutionCategory, updateInstitutionCategory } from '../../services/http';
import { handleMenuSelection, handleSubMenuSelection, reload } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../Loader/Loader';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';

const AddOrEditInstitutionCategory = (props) => {

    const { show, handleClose, idCategory, oldCategoryLabel, operationType } = props;

    const [categoryLabel, setCategoryLabel] = useState({ libelle: "" });
    const [showError, setShowError] = useState({
        libelle: false
    });
    const [errorMessage, setErrorMessage] = useState({
        libelle: ""
    })

    const [processOngoing, setProcessOngoing] = useState(false)
    const [displayLoader, setDisplayLoader] = useState(operationType == "new" ? false : true);


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const id_institution_category = useParams()
    const states = useSelector((state) => state, shallowEqual);

    const handleChangeLabel = (e) => {
        var value = e.currentTarget.value;
        setCategoryLabel({ ...categoryLabel, libelle: value });
    }


    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        let type = operationType === "new" ? "Création" : "Modification"
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "/institution-category", secondLevelText: "Catégorie Institution", secondLevelLink: "", thirdLevelText: type, thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("institution-category", dispatch)
    }, [])


    const handleAddInstititionCategory = async (type) => {
        setProcessOngoing(true)
        console.log("Here is category to add", categoryLabel)
        const reqdata = await addInstitutionCategory(categoryLabel.libelle, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                let errorMsg = reqdata.response?.data.error["libelle"][0];
                console.log("Error Msg ", errorMsg)
                setShowError({ ...showError, libelle: true })
                setErrorMessage({ ...errorMessage, libelle: errorMsg })
            } else {
                setProcessOngoing(false)
                console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data.error, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Nouvelle catégorie ${categoryLabel.libelle} ajoutée avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            setCategoryLabel({ ...categoryLabel, libelle: "" })
            let response = await getInstitutionCategories(states.userToken.access_token, 1, "");

            let response_copy = response.data.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

            dispatch({
                type: "SET",
                key: "institutionCategoriesList",
                payload: response_copy,
            });
            if (type == "retourner") { navigate("/institution-category") }

            // reload();
        }
        //    dispatch({type: "SET",key: "showNewInstitutionCategory", payload: false});
    }

    const handleEditInstititionCategory = async () => {
        setProcessOngoing(true)
        const reqdata = await updateInstitutionCategory(id_institution_category, categoryLabel.libelle, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                let errorMsg = reqdata.response?.data.error["libelle"][0];
                console.log("Error Msg ", errorMsg)
                setShowError({ ...showError, libelle: true })
                setErrorMessage({ ...errorMessage, libelle: errorMsg })
            } else {
                setProcessOngoing(false)
                console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data.error, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Modification effectuée avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            let response = await getInstitutionCategories(states.userToken.access_token, 1, "");
            let response_copy = response.data.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
            dispatch({
                type: "SET",
                key: "institutionCategoriesList",
                payload: response_copy,
            });
            navigate("/institution-category")
        }
    }


    useEffect(() => {
        if (categoryLabel.libelle != "") {
            setShowError({ ...showError, libelle: false })
        }
    }, [categoryLabel])

    // useEffect(() => {
    //     if (showError.libelle === true) {
    //         setTimeout(() => {
    //             setShowError({ ...showError, libelle: false })
    //         }, 5000);
    //     }
    // }, [showError])


    useEffect(() => {
        if (operationType !== "new") {
            loadInstitutionCategoryData();
        }

    }, [])

    const loadInstitutionCategoryData = async () => {
        const resp = await getInstitutionCategory(id_institution_category, states.userToken.access_token)
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            setDisplayLoader(false)
            console.log("data data produit", resp.data)
            setCategoryLabel({ ...categoryLabel, libelle: resp.data.libelle })
        }
    }


    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing m-auto"
                    >

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        {displayLoader == false ?
                        <div className="widget widget-content widget-content-area  mx-auto">
                            <div class="modal-header text-center py-2">
                                <h5 className="">{operationType == "new" ? "Nouvelle Catégorie" : "Modifier Catégorie"}</h5>
                                <button type="button" onClick={() => handleClose(idCategory)} class="close" data-dismiss="modal" aria-label="Close">
                                </button>
                            </div>
                            <Modal.Body className="modal-body">
                                <div class="simple-example  mx-auto">
                                    <div class="form-group row w-80 mx-auto mb-4">
                                        <label for="libelle" class="col-sm-2 col-form-label col-form-label-sm text-dark required">Libellé</label>
                                        <div class="col-sm-10">
                                            <input type="text" onChange={handleChangeLabel} className={showError.libelle == true ? "form-control custom-form-control new-institution-category-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={categoryLabel.libelle} required />
                                            {showError.libelle === true && <span className="new-institution-category-error-span">{errorMessage.libelle}</span>}
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                            <div className="modal-footer">
                                {processOngoing == false ? <Fragment>
                                <button type="button"
                                    title={operationType == "new" ? "Ajouter et rester sur la page" : "Modifier"}
                                    className="btn btn-primary ml-3" onClick={operationType == "new" ? () => handleAddInstititionCategory("rester") : handleEditInstititionCategory}>{operationType == "new" ? "Ajouter et Nouveau" : "Modifier"}</button>
                                {operationType == "new" &&
                                    <button type="button"
                                        title={"Ajouter et retourner à la liste"}
                                        className="btn btn-primary ml-3"
                                        onClick={() => handleAddInstititionCategory("retourner")}>
                                        Ajouter et Retourner</button>
                                }
                                 </Fragment> : <ProcessSpinner />}
                                 <button className="btn ml-3" data-dismiss="modal" onClick={() => navigate("/institution-category")}><i className="flaticon-cancel-12"></i> Retour</button>

                            </div>
                        </div> : <div style={{ marginTop: "25%" }}>
                                    <Loader />
                                </div>
                            }
                    </div>

                </div>
            </div>
        </div>

    )
}

export default AddOrEditInstitutionCategory